import React from "react";
import { string, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import TopArrowContainer from "../TopArrowContainer";
import VersionList from "../VersionList";
import { staticTexts } from "../../utils/Translate";

import "./dropdown.m.css";

const Dropdown = ({ label, publisherAttributes, domainSlug }) => {
  const value = domainSlug === "northamerica" ? "উত্তর আমেরিকা" : staticTexts(publisherAttributes.lang).language;

  return (
    <ul styleName={`wrapper ${publisherAttributes.lang === "en" ? "en-wrapper" : ""}`}>
      <div styleName="edition-label">
        <label styleName="label">{label}</label>
        <span styleName="current-value">{value}</span>
        <i styleName="down" />
        <i styleName="up" />
      </div>
      <div styleName="top-arrow-container-wrapper">
        <TopArrowContainer className="top-arrow-container">
          <VersionList />
        </TopArrowContainer>
      </div>
    </ul>
  );
};

Dropdown.propTypes = {
  label: string,
  publisherAttributes: object,
  domainSlug: string,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
  domainSlug: get(state, ["qt", "config", "domainSlug"], null),
});

export default connect(mapStateToProps, null)(Dropdown);
